import React, { useEffect, useState, createContext } from "react";
import { toast } from "react-toastify";
import { buildColumns } from "../utils/helper";
import useOrder from "../controller/order-controller";

export const ProductListContext = createContext();

export const ProductListContextProvider = ({ children }) => {
  const pageRecord = 10;
  const { getOrderProductDetails, orderProdDetail, isLoading, errMsg } =
    useOrder();
  const [accountId, setAccountId] = useState("");
  const [isLoader, setIsLoader] = useState(true);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [slicedData, setSlicedData] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [flag, setFlag] = useState(true);
  const [orderCol, setOrderCol] = useState("");
  const [orderType, setOrderType] = useState("");
  const [searchContext, setSearchContext] = useState("");
  const [modalTypeContext, setModalTypeContext] = useState("");
  const [isInitial, setIsInitial] = useState(false);

  useEffect(() => {
    if (accountId) {
      setFlag(false);
      setSearchContext("");
      handleGetOrderProducts();
    }
  }, [accountId]);

  useEffect(() => {
    setIsLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  useEffect(() => {
    const header = buildColumns(orderProdDetail?.fields);
    setIsLoader(orderProdDetail?.records ? false : true);
    setColumns(header);
    setData(orderProdDetail?.records);
    pageRecord && setSlicedData(orderProdDetail?.records?.slice(0, pageRecord));

    (orderProdDetail?.totalRecordCount ||
      orderProdDetail?.totalRecordCount === 0) &&
      setTotalPage(
        Math.ceil(
          orderProdDetail?.totalRecordCount
            ? parseInt(orderProdDetail?.totalRecordCount) /
                (pageRecord || orderProdDetail?.recordCount)
            : 1
        )
      );
    (orderProdDetail?.pageNo || orderProdDetail?.pageNo === 0) &&
      setCurrPage(orderProdDetail?.pageNo - 1);
    setIsInitial(true);
  }, [orderProdDetail]);

  useEffect(() => {
    if (orderCol || orderType) {
      setOrderCol("");
      setOrderType("");
    }
    if (!flag) getSearchDebounce(searchContext);
  }, [searchContext]);

  useEffect(() => {
    if (modalTypeContext === "list" && pageRecord) {
      document
        .getElementById("prod-modal-body")
        ?.addEventListener("scroll", scrollToElm);
    }
    return () => window.removeEventListener("scroll", scrollToElm);
  }, [modalTypeContext, data, slicedData, isInitial]);

  // set initial 20 product length
  useEffect(() => {
    if (isInitial) {
      setSlicedData(orderProdDetail?.records?.slice(0, pageRecord));
      setIsInitial(false);
    }
  }, [isInitial]);

  const scrollToElm = (e) => {
    if (
      Math.ceil(e?.target?.scrollTop) >=
        e?.target?.scrollHeight - e?.target?.offsetHeight - 50 &&
      data?.length > slicedData?.length &&
      modalTypeContext === "list" &&
      pageRecord
    ) {
      setSlicedData(
        orderProdDetail?.records?.slice(0, slicedData?.length + pageRecord)
      );
    }
  };

  const getSearchDebounce = (searchVal) => {
    const tempData = orderProdDetail?.records?.filter(
      (dt) =>
        dt?.productName.toUpperCase()?.includes(searchVal.toUpperCase()) ||
        dt?.productId.toUpperCase()?.includes(searchVal.toUpperCase()) ||
        dt?.productCode.toUpperCase()?.includes(searchVal.toUpperCase())
    );
    setData(tempData);
    pageRecord && setSlicedData(tempData?.slice(0, pageRecord));
  };

  const handleGetOrderProducts = (
    page = 0,
    field = "",
    apiField = "",
    dir = ""
  ) => {
    page = page + 1;
    getOrderProductDetails({
      accountId,
      objectName: "Order Product",
      pageNo: page,
      orderByField: field,
      orderByAPIField: apiField,
      orderDirection: dir,
      searchKey: searchContext,
    });
  };

  return (
    <ProductListContext.Provider
      value={{
        setAccountId,
        isLoader,
        columns,
        data,
        slicedData,
        currPage,
        totalPage,
        orderCol,
        setOrderCol,
        orderType,
        setOrderType,
        setSearchContext,
        setModalTypeContext,
        handleGetOrderProducts,
        setIsInitial,
      }}
    >
      {children}
    </ProductListContext.Provider>
  );
};
